import { EventBus } from "@saas/components/src/utils/event-bus";
import { mapMutations, mapState } from "vuex";
import { getRoster, getUserStatus } from "@saas/server-api/src/live-sdk";
import { isWhiteboardAndRecord, isAssistant, isTeacher } from "../utils";
import { debounce } from "@saas/components/src/utils/debounce-async";
import { uploadLiveLog } from "@saas/components/src/utils/log";
import { BatchUpdate } from "../utils/batch-update.js";
import { LAYOUT_MAP } from "../constants.js";
export default {
  data() {
    return {
      // 人员列表
      personList: [],
      // 存储推流状态，用于处理时序问题
      streamStatusCache: new Map(), // key: userID, value: { video: boolean, audio: boolean }
      // 自己的状态变更记录
      changeUserStatus: {},
      // 远端用户的状态变更记录，key 为 user_id，value 为变更的字段
      changeRemoteUserStatus: {},
      // 当前链接状态
      currentLinkStatus: 1, // 1正常 2 断开
      _personListLiveServiceHandlers: {},
      _personListImServiceHandlers: {},
      _personListEventBusHandlers: {},
    };
  },
  created() {},
  mounted() {
    this.initEventBusListeners();
  },
  computed: {
    ...mapState("live", [
      "liveService",
      "imService",
      "deviceSwtich",
      "roomInfo",
      // "members",
      "userStatus",
      "videoPermission",
      "audioPermission",
      "remoteScreenShareInfo",
      "allMemberStatus",
      "isReady",
      "networkOnline",
    ]),
    userInfo() {
      return this.$store.getters.user || {};
    },
    teacherId() {
      return this.roomInfo.teacher_id;
    },
    assistantId() {
      return this.roomInfo.assistant_teacher_id;
    },
    // 1 大班课 2小班课
    roomType() {
      return this.roomInfo.room_type;
    },
    // 是否在接收共享（）
    isScreenShareRemote() {
      return ["start", "pause"].includes(this.remoteScreenShareInfo.status);
    },
  },
  watch: {
    liveService: {
      handler(val, oldValue) {
        if (val && !oldValue) {
          this.liveServiceRegisterListener();
        }
      },
    },
    imService: {
      handler(val, oldValue) {
        if (val && !oldValue) {
          this.imServiceRegisterListener();
        }
      },
    },
    "liveService.isEnterRoomSuccess": {
      handler(val) {
        console.log("new_live_liveService.isEnterRoomSuccess>>>", val);
        if (val) {
          // 先把自己和已经在台上的人员创建出来
          // 根据userstatus 更新台上人员的状态
          this.updateAllMemberStatus(this.userStatus);
          this.handleSelfUpStageInit();
          this.createOnStageList();
          this.$nextTick(() => {
            this.getRosterData();
          });
          uploadLiveLog({
            message: "liveService.isEnterRoomSuccess",
            level: "info",
            tag: "lifecycle",
            extra: {
              component: "person-list-new",
              action: "isEnterRoomSuccess",
            },
          });
        }
      },
      immediate: true,
    },
    personList: {
      deep: true,
      handler(val, oldVal) {
        console.log("new_live_personList_handler__", val, oldVal);
        if (val) {
          const list = [...val];
          this.setMembersStatus(list);
          // 检查人员变化，清理不在列表中用户的缓存
          if (oldVal && oldVal.length > 0) {
            const currentUserIds = new Set(val.map((item) => item.userID));
            const oldUserIds = new Set(oldVal.map((item) => item.userID));

            // 找出被移除的用户
            const removedUsers = [...oldUserIds].filter(
              (userId) => !currentUserIds.has(userId)
            );

            // 清理被移除用户的缓存
            removedUsers.forEach((userId) => {
              this.clearCachedStreamStatus(userId);
            });
          }
          uploadLiveLog({
            message: "personList 发生变化",
            level: "info",
            tag: "api",
            extra: {
              component: "person-list-new",
              action: "personListChange",
              oldVal: oldVal,
              val: val,
            },
          });
        }
      },
    },
    // 设备开关监听
    deviceSwtich: {
      handler(val) {
        if (val) {
          this.personList.forEach((item) => {
            if (item.isMe) {
              item.videoClose = val.camera === "on" ? false : true;
              item.audioClose = val.microphone === "on" ? false : true;
              this.setUserStatus({
                audio_state: item.audioClose ? 2 : 1,
                video_state: item.videoClose ? 2 : 1,
              });
            }
          });
          uploadLiveLog({
            message: "deviceSwtich 发生变化",
            level: "info",
            tag: "api",
            extra: {
              component: "person-list-new",
              action: "deviceSwtichChange",
              val: val,
            },
          });
        }
      },
      deep: true,
    },
    allMemberStatus: {
      handler(val, oldVal) {
        if (val) {
          this.personList.forEach((item) => {
            const member = val.find((fItem) => fItem.user_id === item.userID);
            if (member) {
              item.name = member.nickname || item.name || "";
              item.avatar = member.avatar || item.avatar || "";
              item.audioClose = member.audio_state !== 1;
              item.videoClose = member.video_state !== 1;
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
    isReady: {
      handler(val) {
        if (val && this.liveService.isEnterRoomSuccess) {
          this.notifyDownStage();
        }
        uploadLiveLog({
          message: "isReady 发生变化",
          level: "info",
          tag: "api",
          extra: {
            component: "person-list-new",
            action: "isReadyChange",
            val: val,
          },
        });
      },
      immediate: true,
    },
    networkOnline: {
      handler(val) {
        if (val) {
          this.onConnectionRecovery();
        }
        uploadLiveLog({
          message: "networkOnline 发生变化",
          level: "info",
          tag: "api",
          extra: {
            component: "person-list-new",
            action: "networkOnlineChange",
            val: val,
          },
        });
      },
    },
  },

  methods: {
    ...mapMutations("live", [
      "setMembersStatus",
      "setUserStatus",
      "setAllMemberStatus",
      "setAllMemberStatusMap",
      "setShowOpenAudioDialog",
      "setShowOpenVideoDialog",
      "setMemberOnlineStatus",
      "setRoomInfo",
    ]),
    // 获取缓存的推流状态
    getCachedStreamStatus(userID, type) {
      const cached = this.streamStatusCache.get(userID);
      if (cached && cached[type] !== undefined) {
        return cached[type];
      }
      return false;
    },
    // 清理缓存的推流状态
    clearCachedStreamStatus(userID) {
      this.streamStatusCache.delete(userID);
      uploadLiveLog({
        message: "clearCachedStreamStatus",
        level: "info",
        tag: "api",
        extra: {
          component: "person-list-new",
          action: "clearCachedStreamStatus",
          userId: userID,
        },
      });
    },
    initEventBusListeners() {
      this._personListEventBusHandlers = {
        downstage: (res) => {
          this.onReciveDownStage(res, this.userInfo.user_id);
        },
        removeStudent: (res) => {
          this.handleRemoveStudent(res.userId);
        },
        member_hand_up: (res) => {
          this.onMemberHandUp({ user_id: res.user_id });
        },
        videoMute: (res) => {
          this.onReciveVideoMute(res, this.userInfo.user_id);
        },
        audioMute: (res) => {
          this.onReciveAudioMute(res, this.userInfo.user_id);
        },
        trophy: (res) => {
          this.onReciveTrophy(res);
        },
      };
      Object.keys(this._personListEventBusHandlers).forEach((eventName) => {
        EventBus.$on(eventName, this._personListEventBusHandlers[eventName]);
      });
    },
    // 初始化的时候，如果上台，通知其他人自己上台
    notifyDownStage() {
      if (this.isReady) {
        this.imService.sendMGLiveRoomCustomMsg({
          cmdId: 2,
          data: {
            type: "initUserStatus",
            data: {
              ...this.userStatus,
            },
          },
        });
        this.imService.sendMGLiveRoomCustomMsg({
          cmdId: 2,
          data: {
            type: "userStatus",
            data: {
              ...this.userStatus,
            },
          },
        });
        uploadLiveLog({
          message: "initUserStatus",
          level: "info",
          tag: "api",
          extra: {
            component: "person-list-new",
            action: "notifyDownStage",
            userStatus: this.userStatus,
          },
        });
      }
    },
    // 创建上台人员
    createUpStagePerson(data = {}, isSelf = false) {
      const isExist = this.personList.some(
        (item) => item.userID === data.userID
      );
      uploadLiveLog({
        message: "createUpStagePerson",
        level: "info",
        tag: "api",
        extra: {
          component: "person-list-new",
          action: "createUpStagePerson",
          val: data,
          isSelf: isSelf,
          isWhiteboardAndRecord: isWhiteboardAndRecord(data.userID),
          isTeacher: isTeacher(data.userID, this.roomInfo),
          isAssistant: isAssistant(data.userID, this.roomInfo),
          isExist: isExist,
        },
      });
      if (!data.userID) {
        return;
      }
      if (isWhiteboardAndRecord(data.userID)) {
        return;
      }
      if (isExist) {
        return;
      }
      const isTeacherRole = isTeacher(data.userID, this.roomInfo);
      const isAssistantRole = isAssistant(data.userID, this.roomInfo);
      const info = isSelf
        ? this.userStatus
        : this.allMemberStatus.find((item) => {
            return item.user_id === data.userID;
          }) || {};
      const student = {
        avatar: data.avatar || info.avatar || "",
        userID: data.userID,
        audioClose: data.audio_state === 2 || false,
        videoClose: data.video_state === 2 || false,
        name: data.nickname || info.nickname || "",
        isTeacher: isTeacherRole,
        isAssistant: isAssistantRole,
        isMe: isSelf,
        isHandUp: false,
        trophyCount: data.trophy_count || info.trophy_count || 0,
        isReciveStream:
          data.isReciveStream ||
          this.getCachedStreamStatus(data.userID, "video") ||
          false,
        isReciveAudioStream:
          data.isReciveAudioStream ||
          this.getCachedStreamStatus(data.userID, "audio") ||
          false,
      };
      uploadLiveLog({
        message: "createUpStagePerson----success",
        level: "info",
        tag: "api",
        extra: {
          component: "person-list-new",
          action: "createUpStagePerson",
          studentInfo: student,
        },
      });
      if (student.isTeacher) {
        this.personList.unshift(student);
      } else if (student.isMe) {
        const isHaveTeacher = this.personList.some((item) => {
          return item.isTeacher;
        });
        if (isHaveTeacher) {
          // 插入到第二个
          this.personList.splice(1, 0, student);
        } else {
          // 插入到第一个
          this.personList.unshift(student);
        }
      } else {
        const tempIndex = this.personList.findIndex((item) => {
          return item.userID === student.userID;
        });
        if (tempIndex > -1) {
          this.$set(
            this.personList,
            tempIndex,
            Object.assign({}, this.personList[tempIndex], student)
          );
        } else {
          this.personList.push(student);
        }
      }
    },
    liveServiceRegisterListener() {
      this._personListLiveServiceHandlers = {
        userVideoAvailable: (res) => {
          console.log("new_live_userVideoAvailable", res);
          this.onUserVideoAvailable(res);
        },
        userAudioAvailable: (res) => {
          console.log("new_live_userAudioAvailable", res);
          this.onUserAudioAvailable(res);
        },
        remoteUserLeaveRoom: (res) => {
          console.log("new_live__content_remoteUserLeaveRoom", res);
          this.onRemoteUserLeaveRoom(res);
        },
        remoteUserEnterRoom: (res) => {
          console.log("new_live__content_remoteUserEnterRoom", res);
          this.onRemoteUserEnterRoom(res);
        },
        tryToReconnect: () => {
          // this.onTryToReconnect(res);
        },
        connectionLost: () => {
          this.onConnectionLost();
        },
        connectionRecovery: () => {
          this.onConnectionRecovery();
        },
      };
      Object.keys(this._personListLiveServiceHandlers).forEach((eventName) => {
        this.liveService.on(
          eventName,
          this._personListLiveServiceHandlers[eventName]
        );
      });
    },
    imServiceRegisterListener() {
      this._personListImServiceHandlers = {
        recvMGLiveRoomCustomMsg: (res) => {
          const { data, userId } = res;
          console.log("new_live_imServiceRegisterListener>>>", res);
          if (data.type === "videoMute") {
            this.onReciveVideoMute(data.data, userId);
          } else if (data.type === "audioMute") {
            this.onReciveAudioMute(data.data, userId);
          } else if (data.type === "downstage") {
            this.onReciveDownStage(data.data, userId);
          } else if (data.type === "removeStudent") {
            // 移除学员
            this.onRemoveStudent(data.data);
          } else if (data.type === "member_hand_up") {
            this.onMemberHandUp(data.data);
          } else if (data.type === "userStatus") {
            // 当收到用户状态更新
            this.onReciveUserStatusChange(data.data);
          } else if (data.type === "updateNickname") {
            this.onReciveUpdateNickname(data.data);
          } else if (data.type === "whiteboard") {
            this.onReciveWhiteBoard(data.data);
          } else if (data.type === "messageMute") {
            console.log("new_live_onReciveMessageMute>>>", data.data, userId);
            this.onReciveMessageMute(data.data, userId);
          } else if (data.type === "initUserStatus") {
            this.onReciveInitUserStatus(data.data);
          } else if (data.type === "getUserStatus") {
            this.onReciveGetUserStatus(data.data);
          } else if (data.type === "trophy") {
            this.onReciveTrophy(data.data);
          }
          uploadLiveLog({
            message: "imServiceRegisterListener---recvMGLiveRoomCustomMsg",
            level: "info",
            tag: "callback",
            extra: {
              component: "person-list-new",
              action: "imServiceRegisterListener",
              data: data.data,
              type: data.type,
              fromUserId: userId,
            },
          });
        },
      };
      Object.keys(this._personListImServiceHandlers).forEach((eventName) => {
        this.imService.on(
          eventName,
          this._personListImServiceHandlers[eventName]
        );
      });
    },
    // 连接断开
    onConnectionLost: debounce(function () {
      if (this.roomInfo.id && this.liveService.isEnterRoomSuccess) {
        if (this.currentLinkStatus === 1) {
          this.$darkMessage.warning("连接断开");
        }
        this.currentLinkStatus = 2;
      }
    }, 1000),
    // 连接恢复
    onConnectionRecovery: debounce(function () {
      if (this.roomInfo.id && this.liveService.isEnterRoomSuccess) {
        // 重新获取自己的状态
        this.getSelfStatus();
        // 重新获取其他人的状态
        this.getOtherStatus();
        if (this.currentLinkStatus === 2) {
          this.$darkMessage.success("连接恢复");
        }
        this.currentLinkStatus = 1;
      }
    }, 1000),
    onReciveInitUserStatus(data = {}) {
      if (!data.user_id) {
        return;
      }
      if (data.is_up_stage === 1) {
        // 远端用户初始化上台
        this.handleRemoteUpStage({
          userId: data.user_id,
          audio_state: data.audio_state,
          video_state: data.video_state,
        });
      } else {
        // 远端用户下台
        this.handleRemoteDownStage(data.user_id);
      }
    },
    onReciveGetUserStatus() {
      this.notifyDownStage();
    },
    onReciveTrophy(data = {}) {
      const { userId } = data;
      if (userId === "*") {
        // 全员获得奖杯
        this.personList.forEach((item) => {
          item.trophyCount = item.trophyCount + 1;
        });
      } else {
        const student = this.personList.find((item) => item.userID === userId);
        if (student) {
          this.$set(student, "trophyCount", student.trophyCount + 1);
        }
      }
      if (
        this.roomInfo.isStudent &&
        (userId === this.userStatus.user_id || userId === "*")
      ) {
        // 学员自己获得奖杯
        this.setUserStatus({
          trophy_count: this.userStatus.trophy_count + 1,
        });
      }
    },
    onReciveUpdateNickname(data = {}) {
      console.log("new_live_onReciveUpdateNickname>>>", data);
      const { userId, nickname } = data;
      if (userId === this.userStatus.user_id) {
        this.changeUserStatus.nickname = nickname;
        this.setUserStatus({
          nickname: nickname,
        });
      } else {
        this.recordRemoteUserStatusChange(userId, { nickname });
      }
    },
    onReciveWhiteBoard(data = {}) {
      const { isWhiteboard, userId } = data;
      const isSelf = userId === this.userStatus.user_id || userId === "*";
      if (isSelf) {
        this.setUserStatus({
          is_whiteboard: isWhiteboard ? 1 : 2,
        });
        this.changeUserStatus.is_whiteboard = isWhiteboard;
      }
    },
    onReciveMessageMute(data = {}, fromUserId = "") {
      const { userId, isMute } = data;
      console.log("new_live_onReciveMessageMute>>>", data);
      if (userId === "*") {
        this.setRoomInfo({
          is_send_msg: isMute ? 2 : 1,
        });
        // 全员禁言
        if (isTeacher(fromUserId)) {
          // 老师操作全员关闭消息
          this.setUserStatus({
            is_send_msg: isMute ? 2 : 1,
          });
          this.changeUserStatus.is_send_msg = isMute ? 2 : 1;
        } else if (isAssistant(fromUserId) && this.roomInfo.isStudent) {
          // 助教操作全员关闭消息
          this.setUserStatus({
            is_send_msg: isMute ? 2 : 1,
          });
          this.changeUserStatus.is_send_msg = isMute ? 2 : 1;
        }
      } else if (userId === this.userStatus?.user_id) {
        // 单个用户关闭消息
        this.setUserStatus({
          is_send_msg: isMute ? 2 : 1,
        });
        this.changeUserStatus.is_send_msg = isMute ? 2 : 1;
      }
    },
    // 当有人进入房间,学员列表新增学员
    onRemoteUserEnterRoom(res) {
      // const info = this.allMemberStatus.find(
      //   (item) => item.user_id === res.userID
      // );
      // console.log("new_live_onRemoteUserEnterRoom_info", info);
      // if (info && info.is_up_stage === 1) {
      //   // 在这里主要是处理断网重连时，如果是在台上需要创建
      //   this.handleRemoteUpStage({ userId: res.userID });
      // }
      this.setMemberOnlineStatus({
        [res.userID]: 1,
      });
      this.updateAllMemberStatus({
        user_id: res.userID,
        status: 1,
      });
    },
    // 当有学员离开,学员列表移除学员
    onRemoteUserLeaveRoom(data = {}) {
      this.handleRemoteDownStage(data.userID, false);
      this.clearCachedStreamStatus(data.userID);
      this.setMemberOnlineStatus({
        [data.userID]: 0,
      });
      this.updateAllMemberStatus({
        user_id: data.userID,
        status: 2,
        audio_state: 2,
        video_state: 2,
      });
    },
    // 当有人开启/关闭视频推流
    onUserVideoAvailable(res) {
      console.log("new_live_userVideoAvailable>", res);
      const isExist = this.personList.some((item) => {
        return item.userID === res.userID;
      });
      uploadLiveLog({
        message: "onUserVideoAvailable",
        level: "info",
        tag: "callback",
        extra: {
          component: "person-list-new",
          action: "onUserVideoAvailable",
          val: res,
          isWhiteboardAndRecord: isWhiteboardAndRecord(res.userID),
          isExist: isExist,
        },
      });
      // 过滤掉白板
      if (res.userID && isWhiteboardAndRecord(res.userID)) {
        return;
      }
      if (res.streamType === "sub") {
        return;
      }
      if (isExist) {
        this.personList.forEach((item) => {
          if (item.userID === res.userID) {
            item.isReciveStream = res.available === 1 ? true : false;
          }
        });
      } else {
        this.streamStatusCache.set(res.userID, {
          ...this.streamStatusCache.get(res.userID),
          video: res.available === 1,
        });
        console.log(
          `缓存用户 ${res.userID} 的视频推流状态: ${res.available === 1}`
        );
        uploadLiveLog({
          message: `缓存用户 ${res.userID} 的视频推流状态: ${
            res.available === 1
          }`,
          level: "info",
          tag: "callback",
          extra: {
            component: "person-list-new",
            action: "onUserVideoAvailable",
            val: res,
          },
        });
      }
      console.log("new_live_this.personList", this.personList);
    },
    // 当有人开启/关闭音频推流
    onUserAudioAvailable(res) {
      console.log("new_live_person-list_userAudioAvailable>>>", res);
      const isExist = this.personList.find((item) => {
        return item.userID === res.userID;
      });
      uploadLiveLog({
        message: "onUserAudioAvailable",
        level: "info",
        tag: "callback",
        extra: {
          component: "person-list-new",
          action: "onUserAudioAvailable",
          val: res,
          isWhiteboardAndRecord: isWhiteboardAndRecord(res.userID),
          isExist: isExist,
        },
      });
      if (res.userID && isWhiteboardAndRecord(res.userID)) {
        return;
      }
      // 开启
      if (isExist) {
        this.personList.forEach((item) => {
          if (item.userID === res.userID) {
            item.isReciveAudioStream = res.available === 1 ? true : false;
          }
        });
      } else {
        this.streamStatusCache.set(res.userID, {
          ...this.streamStatusCache.get(res.userID),
          audio: res.available === 1,
        });
        console.log(
          `new_live_缓存用户 ${res.userID} 的音频推流状态: ${
            res.available === 1
          }`
        );
        uploadLiveLog({
          message: `缓存用户 ${res.userID} 的音频推流状态: ${
            res.available === 1
          }`,
          level: "info",
          tag: "callback",
          extra: {
            component: "person-list-new",
            action: "onUserAudioAvailable",
            val: res,
          },
        });
      }
    },
    // 当移除学员
    onRemoveStudent(data) {
      const { userId } = data;
      if (this.userInfo.user_id === userId) {
        this.$refs.kickedDialog.open();
        this.liveService?.exitRoom();
        this.handleSelfDownStage();
      } else {
        this.handleRemoteDownStage(userId);
      }
    },
    onMemberHandUp(data = {}) {
      console.log("new_live_member_hand_up>>>>");
      console.log(data);
      const { user_id } = data;
      this.personList.forEach((item) => {
        if (item.userID === user_id) {
          item.isHandUp = true;
        }
      });
      setTimeout(() => {
        this.personList.forEach((item) => {
          if (item.userID === user_id) {
            item.isHandUp = false;
          }
        });
      }, 10000);
    },
    // 移除学员
    handleRemoveStudent(userId = "") {
      this.personList.forEach((item) => {
        if (!item.isTeacher) {
          if (item.userID === userId) {
            item.downstage = true;
          }
          this.$nextTick(() => {
            this.personList = this.personList.filter((item) => {
              return !item.downstage;
            });
          });
        }
      });
    },
    // 当有人员的状态更新
    onReciveUserStatusChange(data = {}) {
      const userId = data.user_id;
      const fIndex = this.personList.findIndex(
        (item) => item.userID === userId
      );
      if (fIndex > -1) {
        this.$set(this.personList, fIndex, {
          ...this.personList[fIndex],
          audioClose: data.audio_state !== 1,
          videoClose: data.video_state !== 1,
          name: data.nickname || this.personList[fIndex].name,
          avatar: data.avatar || this.personList[fIndex].avatar,
          trophyCount: data.trophy_count || 0,
        });
      }
      // 判断状态里有没有这个用户，如果没有代表第一次进入房间
      const isHaveUser = this.allMemberStatus.some(
        (item) => item.user_id === userId
      );
      if (!isHaveUser && data.is_up_stage === 1 && userId) {
        this.createUpStagePerson({
          userID: userId,
          audio_state: data.audio_state === 1 ? 1 : 2,
          video_state: data.video_state === 1 ? 1 : 2,
          nickname: data.nickname,
          avatar: data.avatar,
          trophyCount: data.trophy_count || 0,
        });
      }
      this.updateAllMemberStatus({
        user_id: userId,
        audio_state: data.audio_state === 1 ? 1 : 2,
        video_state: data.video_state === 1 ? 1 : 2,
        nickname: data.nickname,
        avatar: data.avatar,
        trophy_count: data.trophy_count || 0,
      });
    },
    // 更新所有人员状态
    updateAllMemberStatus(data = {}) {
      uploadLiveLog({
        message: "updateAllMemberStatus--before",
        level: "info",
        tag: "api",
        extra: {
          component: "person-list-new",
          action: "updateAllMemberStatus",
          data: data,
        },
      });
      if (!data.user_id) {
        return;
      }
      const list = this.allMemberStatus;
      const fObj = this.allMemberStatus.findIndex(
        (item) => item.user_id === data.user_id
      );
      if (fObj > -1) {
        // 判断如果值完全相等就不处理
        const hasChanges = Object.keys(data).some((key) => {
          const oldValue = list[fObj][key];
          const newValue = data[key];
          // 处理 undefined 的情况：如果都是 undefined，认为没有变化
          if (oldValue === undefined && newValue === undefined) {
            return false;
          }
          return oldValue !== newValue;
        });
        if (!hasChanges) {
          return;
        }
        list[fObj] = { ...list[fObj], ...data };
      } else {
        list.push({ ...data, userID: data.user_id });
      }
      this.setAllMemberStatus(list);
      this.setAllMemberStatusMap({
        ...data,
      });
    },
    // 初始化的时候把已经在台上的人员创建出来
    createOnStageList() {
      const list = this.roomInfo.user_list || [];
      list.forEach((item) => {
        this.createUpStagePerson({
          userID: item.user_id,
          avatar: item.avatar,
          nickname: item.nickname,
          audio_state: item.is_send_audio !== 1 ? 2 : item.audio_state,
          video_state: item.is_send_video !== 1 ? 2 : item.video_state,
        });
      });
    },
    // 初始化获取举手人员
    getRosterData() {
      this.loading = true;
      getRoster({
        room_id: this.roomInfo.id,
        hand_up: 1,
      }).then((res) => {
        if (res.code === 1) {
          this.handUplist = res.data.list || [];
          this.handUplist.forEach((handItem) => {
            if (Date.now() - handItem.hand_up_time * 1000 < 10000) {
              this.personList.forEach((item) => {
                if (item.userID === handItem.user_id) {
                  item.isHandUp = true;
                  setTimeout(() => {
                    this.personList.forEach((fItem) => {
                      if (fItem.userID === item.userID) {
                        fItem.isHandUp = false;
                      }
                    });
                  }, 10000);
                }
              });
            }
          });
        }
      });
    },
    // 重新获取自己的状态
    getSelfStatus() {
      this.changeUserStatus = {};
      getUserStatus({ room_id: this.roomInfo.id }).then((res) => {
        if (res.code === 1) {
          const { data } = res;
          const audioState =
            this.changeUserStatus.is_send_audio === 1
              ? this.userStatus.audio_state
              : 2;
          const videoState =
            this.changeUserStatus.is_send_video === 1
              ? this.userStatus.video_state
              : 2;
          const newStatus = {
            ...data,
            ...this.changeUserStatus,
            user_id: this.userStatus.user_id,
            audio_state: audioState,
            video_state: videoState,
          };
          this.setUserStatus(
            {
              ...newStatus,
            } || {}
          );
          if (newStatus.is_up_stage === 1) {
            this.handleSelfUpStage({
              isSendAudio: newStatus.is_send_audio,
              isSendVideo: newStatus.is_send_video,
            });
          } else {
            this.handleSelfDownStage();
          }
          this.notifyDownStage();
        }
      });
    },
    /**
     * 获取其他用户的状态
     * 在接口请求期间，如果收到 IM 消息更新了远端用户状态，会保存在 changeRemoteUserStatus 中
     * 接口返回后会用 changeRemoteUserStatus 覆盖接口数据，确保状态是最新的
     */
    getOtherStatus() {
      // 清空远端用户状态变更记录
      this.changeRemoteUserStatus = {};
      this.imService.sendMGLiveRoomCustomMsg({
        cmdId: 2,
        data: {
          type: "getUserStatus",
        },
      });
    },

    /**
     * 记录远端用户的状态变更
     * @param {String} userId - 用户ID
     * @param {Object} changes - 变更的字段
     */
    recordRemoteUserStatusChange(userId, changes) {
      if (!userId || userId === this.userInfo.user_id) {
        return;
      }

      if (!this.changeRemoteUserStatus[userId]) {
        this.changeRemoteUserStatus[userId] = {};
      }

      // 合并变更
      this.changeRemoteUserStatus[userId] = {
        ...this.changeRemoteUserStatus[userId],
        ...changes,
      };

      console.log("记录远端用户状态变更", {
        userId,
        changes,
        当前记录: this.changeRemoteUserStatus[userId],
      });
    },
    // 获取
    //////////////////////////////////////////////// 上下台相关操作 ////////////////////////////////////////////////
    // 接收上下台
    onReciveDownStage(data = {}, fromUserId = "") {
      try {
        const { userId } = data;
        if (userId === "*") {
          this.handleAllDownstage(fromUserId);
        } else {
          this.handleDownstage(data);
        }
      } catch (error) {
        console.error("new_live_person-list_downstage__error", error);
      }
    },
    // 全体下台
    handleAllDownstage(fromUserId = "") {
      console.log("全部下台");
      uploadLiveLog({
        message: "handleAllDownstage---before",
        level: "info",
        tag: "api",
        extra: {
          component: "person-list-new",
          action: "handleAllDownstage",
          fromUserId: fromUserId,
          personList: this.personList,
          isTeacher: isTeacher(fromUserId),
          isAssistant: isAssistant(fromUserId),
        },
      });
      let keepList = [];
      let removeList = [];
      if (isTeacher(fromUserId)) {
        // 老师操作全体下台 只留老师
        keepList = this.personList.filter((item) => {
          return item.isTeacher;
        });
        removeList = this.personList.filter((item) => {
          return !item.isTeacher;
        });
      } else if (isAssistant(fromUserId)) {
        // 助教操作全体下台 只留老师和助教
        keepList = this.personList.filter((item) => {
          return item.isAssistant || item.isTeacher;
        });
        removeList = this.personList.filter((item) => {
          return !item.isAssistant && !item.isTeacher;
        });
      }
      uploadLiveLog({
        message: "handleAllDownstage",
        level: "info",
        tag: "api",
        extra: {
          component: "person-list-new",
          action: "handleAllDownstage",
          keepList: keepList,
          removeList: removeList,
        },
      });
      console.log("keepList", keepList);
      console.log("removeList", removeList);
      this.personList = keepList;
      removeList.forEach((item) => {
        if (item.isMe) {
          this.handleSelfDownStage();
        } else {
          this.handleRemoteDownStage(item.userID);
        }
      });
    },
    // 操作某人上下台
    handleDownstage(data = {}) {
      const { userId, isDown, isWhiteboard, isSendAudio, isSendVideo } = data;
      if (this.roomInfo.teacher_id === userId) {
        return;
      }
      const isSelf = userId === this.userInfo.user_id;
      if (isSelf && isDown) {
        this.handleSelfDownStage();
      } else if (isSelf && !isDown) {
        this.handleSelfUpStage(data);
      } else if (!isSelf && isDown) {
        // 远端用户下台
        this.handleRemoteDownStage(userId);
      } else {
        // 远端用户上台
        this.handleRemoteUpStage(data);
      }
    },
    // 自己上台
    handleSelfUpStage(params = {}) {
      console.log("handleSelfUpStage", params);
      const { isSendAudio, isSendVideo, isWhiteboard } = params;
      const currentWhiteBoard = this.userStatus.is_whiteboard === 1;
      const status = {
        is_send_audio: isSendAudio === 1 ? 1 : 2,
        is_send_video: isSendVideo === 1 ? 1 : 2,
        is_whiteboard: currentWhiteBoard ? 1 : isWhiteboard === 1 ? 1 : 2,
        audio_state: isTeacher(this.userStatus.user_id) ? 1 : 2,
        video_state: isTeacher(this.userStatus.user_id) ? 1 : 2,
        is_up_stage: 1,
      };
      const isOnstage = this.personList.some(
        (item) => item.userID === this.userInfo.user_id
      );
      if (!isOnstage) {
        this.createUpStagePerson(
          {
            userID: this.userInfo.user_id,
            ...status,
          },
          true
        );
      }
      if (isSendAudio === 1 && !isTeacher(this.userStatus.user_id)) {
        this.setShowOpenAudioDialog(true);
        uploadLiveLog({
          message: "handleSelfUpStage-setShowOpenAudioDialog-true",
          level: "info",
          tag: "api",
          extra: {
            component: "person-list-new",
            action: "handleSelfUpStage",
          },
        });
      } else {
        this.setShowOpenAudioDialog(false);
        uploadLiveLog({
          message: "handleSelfUpStage-setShowOpenAudioDialog-false",
          level: "info",
          tag: "api",
          extra: {
            component: "person-list-new",
            action: "handleSelfUpStage",
          },
        });
      }
      if (isSendVideo === 1 && !isTeacher(this.userStatus.user_id)) {
        this.setShowOpenVideoDialog(true);
        uploadLiveLog({
          message: "handleSelfUpStage-setShowOpenVideoDialog-true",
          level: "info",
          tag: "api",
          extra: {
            component: "person-list-new",
            action: "handleSelfUpStage",
          },
        });
      } else {
        this.setShowOpenVideoDialog(false);
        uploadLiveLog({
          message: "handleSelfUpStage-setShowOpenVideoDialog-false",
          level: "info",
          tag: "api",
          extra: {
            component: "person-list-new",
            action: "handleSelfUpStage",
          },
        });
      }
      this.setUserStatus({
        ...status,
      });
      uploadLiveLog({
        message: "handleSelfUpStage",
        level: "info",
        tag: "api",
        extra: {
          component: "person-list-new",
          action: "handleSelfUpStage",
        },
      });
      // 如果是学生或者助教并且是大班课，需要根据房间里面的布局来设置自己的布局
      // 如果是演讲者模式，学生或者助教需要改成vertical模式
      // if (
      //   (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
      //   this.roomInfo.room_type === 1
      // ) {
      //   if (this.roomInfo.live_layout === 3) {
      //     this.setLayout("vertical");
      //   } else {
      //     this.setLayout(LAYOUT_MAP[this.roomInfo.live_layout]);
      //   }
      // }
    },
    // 自己下台
    handleSelfDownStage() {
      this.personList = this.personList.filter((item) => {
        return item.userID !== this.userStatus.user_id;
      });
      this.setUserStatus({
        is_up_stage: 2,
        audio_state: 2,
        video_state: 2,
        is_send_audio: 2,
        is_send_video: 2,
      });
      this.setShowOpenVideoDialog(false);
      this.setShowOpenAudioDialog(false);
      uploadLiveLog({
        message: "handleSelfDownStage-setShowOpenAudioDialog-false",
        level: "info",
        tag: "api",
        extra: {
          component: "person-list-new",
          action: "handleSelfDownStage",
        },
      });
      if (this.liveService) {
        this.liveService.stopLocalPreview();
        this.liveService.muteLocalAudio({ mute: true });
      }
      this.changeUserStatus.is_up_stage = 2;
      this.changeUserStatus.audio_state = 2;
      this.changeUserStatus.video_state = 2;
      this.changeUserStatus.is_send_audio = 2;
      this.changeUserStatus.is_send_video = 2;
      uploadLiveLog({
        message: "handleSelfDownStage",
        level: "info",
        tag: "api",
        extra: {
          component: "person-list-new",
          action: "handleSelfDownStage",
          userStatus: this.userStatus,
          personList: this.personList,
        },
      });
    },
    // 远端用户上台
    handleRemoteUpStage(params = {}) {
      const { userId } = params;
      const remoteMember = this.allMemberStatus.find(
        (item) => item.user_id === userId
      );
      console.log("remoteMember", remoteMember);
      this.createUpStagePerson({
        userID: userId,
        audio_state: params.audio_state === 1 ? 1 : 2,
        video_state: params.video_state === 1 ? 1 : 2,
        nickname: remoteMember ? remoteMember.nickname || "" : "",
        avatar: remoteMember ? remoteMember.avatar || "" : "",
        trophyCount: remoteMember ? remoteMember.trophy_count || 0 : 0,
      });
      this.updateAllMemberStatus({
        user_id: userId,
        is_up_stage: 1,
      });
      uploadLiveLog({
        message: "handleRemoteUpStage",
        level: "info",
        tag: "api",
        extra: {
          component: "person-list-new",
          action: "handleRemoteUpStage",
          params: params,
          remoteMember: remoteMember,
        },
      });
    },
    // 远端用户下台 isChangeStatus 是否改变状态
    handleRemoteDownStage(userId, isChangeStatus = true) {
      try {
        if (userId !== this.userInfo.user_id) {
          this.personList = this.personList.filter((item) => {
            return item.userID !== userId;
          });
          if (this.liveService) {
            this.liveService.stopRemoteView({
              userID: userId,
              streamType: 0,
            });
            this.liveService.muteRemoteAudio({
              userId: userId,
              mute: true,
            });
          }
          if (isChangeStatus) {
            this.updateAllMemberStatus({
              user_id: userId,
              is_up_stage: 2,
            });
            // this.recordRemoteUserStatusChange(userId, {
            //   is_up_stage: 2,
            // });
          }
          uploadLiveLog({
            message: "handleRemoteDownStage",
            level: "info",
            tag: "api",
            extra: {
              component: "person-list-new",
              action: "handleRemoteDownStage",
              userId: userId,
              personList: this.personList,
              isChangeStatus: isChangeStatus,
            },
          });
        }
      } catch (error) {
        console.error("远端用户下台失败:", error);
        uploadLiveLog({
          message: "handleRemoteDownStage---error",
          level: "error",
          tag: "api",
          extra: {
            component: "person-list-new",
            action: "handleRemoteDownStage",
            error: error?.message || error,
            userId: userId,
          },
        });
      }
    },
    // 页面初始化的时候自己上台
    handleSelfUpStageInit() {
      // 如果是老师直接上台，如果非老师需要判断自己的权限是否可以上台，可以上台直接创建
      if (
        this.roomInfo.isTeacher ||
        (this.roomInfo.isAssistant && this.userStatus.is_up_stage === 1)
      ) {
        // 当前用户是老师/助教并且有权限自动上台, 有权限并且打开摄像头和麦克风
        const audioState =
          this.deviceSwtich.microphone === "on" && this.audioPermission ? 1 : 2;
        const videoState =
          this.deviceSwtich.camera === "on" && this.videoPermission ? 1 : 2;
        const status = {
          is_up_stage: 1,
          is_send_audio: 1,
          is_send_video: 1,
          audio_state: audioState,
          video_state: videoState,
        };
        if (this.roomInfo.mode == 1) {
          status.video_state = 2;
        }
        this.createUpStagePerson(
          {
            userID: this.userInfo.user_id,
            nickname: this.userStatus.nickname,
            ...status,
          },
          true
        );
        this.setUserStatus(status);
        // this.notifyDownStage();
      } else {
        if (this.userStatus.is_up_stage === 1) {
          // 自己可以上台，如果有权限开启摄像头和麦克风，就自动开启
          const status = {
            is_send_audio: this.userStatus.is_send_audio,
            is_send_video: this.userStatus.is_send_video,
            audio_state: 2,
            video_state: 2,
          };
          this.createUpStagePerson(
            {
              userID: this.userInfo.user_id,
              nickname: this.userStatus.nickname,
              ...status,
            },
            true
          );
          if (this.userStatus.is_send_audio === 1 && this.audioPermission) {
            this.setShowOpenAudioDialog(true);
            uploadLiveLog({
              message: "handleSelfUpStage-setShowOpenAudioDialog-true",
              level: "info",
              tag: "api",
              extra: {
                component: "person-list-new",
                action: "handleSelfUpStage",
              },
            });
          }
          if (this.userStatus.is_send_video === 1 && this.videoPermission) {
            this.setShowOpenVideoDialog(true);
            uploadLiveLog({
              message: "handleSelfUpStage-setShowOpenVideoDialog-true",
              level: "info",
              tag: "api",
              extra: {
                component: "person-list-new",
                action: "handleSelfUpStage",
              },
            });
          }
          this.setUserStatus(status);
          // this.notifyDownStage();
        }
      }
      this.notifyDownStage();
    },
    //////////////////////////////////////////////// 麦克风相关操作 ////////////////////////////////////////////////
    onReciveAudioMute(data = {}, fromUserId = "") {
      console.log("new_live_person-list_onReciveAudioMute__", data, fromUserId);
      const { userId, isMute } = data;
      if (userId === "*") {
        this.handleAllAudioMute(fromUserId, isMute);
      } else {
        if (userId === this.userInfo.user_id) {
          this.handleSelfAudioMute({ isMute }, fromUserId);
        } else {
          this.handleRemoteAudioMute({ userId, isMute });
        }
      }
    },
    // 全体关闭麦克风/打开麦克风
    handleAllAudioMute(fromUserId, isMute) {
      const isFromTeacher = isTeacher(fromUserId);
      const isFromAssistant = isAssistant(fromUserId);
      if (isFromTeacher) {
        // 如果老师操作全体关闭/打开麦克风，其他所有人都要关闭/打开麦克风
        this.personList.forEach((item) => {
          if (!item.isTeacher && item.isMe) {
            this.handleSelfAudioMute({ isMute }, fromUserId);
          } else if (!item.isTeacher && !item.isMe) {
            this.handleRemoteAudioMute({ userId: item.userID, isMute });
          }
        });
      } else if (isFromAssistant) {
        // 如果助教操作关闭/打开麦克风，只要学生要关闭/打开麦克风
        this.personList.forEach((item) => {
          if (!item.isAssistant && !item.isTeacher && item.isMe) {
            this.handleSelfAudioMute({ isMute }, fromUserId);
          } else if (!item.isAssistant && !item.isTeacher && !item.isMe) {
            this.handleRemoteAudioMute({ userId: item.userID, isMute });
          }
        });
      }
    },
    // 自己的麦克风开/关
    handleSelfAudioMute(data = {}, fromUserId = "") {
      const { isMute } = data;
      const slefItem = this.personList.find(
        (item) => item.userID === this.userInfo.user_id
      );
      const isFromSelf = fromUserId === this.userStatus.user_id;
      if (isFromSelf) {
        // 如果来源是自己，不改自己的权限，只改状态
        this.setUserStatus({
          audio_state: isMute ? 2 : 1,
        });
        this.changeUserStatus.audio_state = isMute ? 2 : 1;
        return;
      }
      if (slefItem) {
        // 如果自己在台上,并且状态不一致,则更新状态
        if (isMute !== slefItem.audioClose && isMute) {
          // 关闭麦克风
          slefItem.audioClose = true;
        } else if (isMute !== slefItem.audioClose && !isMute) {
          // 打开麦克风
          this.setShowOpenAudioDialog(true);
          uploadLiveLog({
            message: "handleSelfAudioMute-setShowOpenAudioDialog-true",
            level: "info",
            tag: "api",
            extra: {
              component: "person-list-new",
              action: "handleSelfAudioMute",
            },
          });
        }
        if (isMute) {
          this.setShowOpenAudioDialog(false);
          uploadLiveLog({
            message: "handleSelfAudioMute-setShowOpenAudioDialog-false",
            level: "info",
            tag: "api",
            extra: {
              component: "person-list-new",
              action: "handleSelfAudioMute",
            },
          });
        }
        this.setUserStatus({
          is_send_audio: isMute ? 2 : 1,
          audio_state: slefItem.audioClose ? 2 : 1,
        });
        this.changeUserStatus.is_send_audio = isMute ? 2 : 1;
        this.changeUserStatus.audio_state = slefItem.audioClose ? 2 : 1;
      } else {
        this.setUserStatus({
          is_send_audio: isMute ? 2 : 1,
          audio_state: 2,
        });
        this.changeUserStatus.is_send_audio = isMute ? 2 : 1;
        this.changeUserStatus.audio_state = 2;
      }
    },
    // 远端用户的麦克风开关
    handleRemoteAudioMute(data = {}) {
      const { userId, isMute } = data;
      const status = {
        user_id: userId,
        is_send_audio: isMute ? 2 : 1,
      };
      if (isMute) {
        status.audio_state = 2;
      }

      // // 记录远端用户的麦克风状态变更
      // this.recordRemoteUserStatusChange(userId, {
      //   is_send_audio: isMute ? 2 : 1,
      //   audio_state: isMute ? 2 : status.audio_state,
      // });

      this.updateAllMemberStatus({
        ...status,
      });
    },
    //////////////////////////////////////////////// 摄像头相关操作 ////////////////////////////////////////////////
    onReciveVideoMute(data = {}, fromUserId = "") {
      console.log("new_live_person-list_onReciveVideoMute__", data, fromUserId);
      const { userId, isMute } = data;
      if (userId === "*") {
        this.handleAllVideoMute(fromUserId, isMute);
      } else {
        if (userId === this.userInfo.user_id) {
          this.handleSelfVideoMute({ isMute }, fromUserId);
        } else {
          this.handleRemoteVideoMute({ userId, isMute });
        }
      }
    },
    // 全体关闭摄像头/打开摄像头
    handleAllVideoMute(fromUserId, isMute) {
      const isFromTeacher = isTeacher(fromUserId);
      const isFromAssistant = isAssistant(fromUserId);
      if (isFromTeacher) {
        // 如果老师操作全体关闭/打开摄像头，其他所有人都要关闭/打开摄像头
        this.personList.forEach((item) => {
          if (!item.isTeacher && item.isMe) {
            this.handleSelfVideoMute({ isMute }, fromUserId);
          } else if (!item.isTeacher && !item.isMe) {
            this.handleRemoteVideoMute({ userId: item.userID, isMute });
          }
        });
      }
      if (isFromAssistant) {
        // 如果助教操作关闭/打开摄像头，只要学生要关闭/打开摄像头
        this.personList.forEach((item) => {
          if (!item.isAssistant && !item.isTeacher && item.isMe) {
            this.handleSelfVideoMute({ isMute }, fromUserId);
          } else if (!item.isAssistant && !item.isTeacher && !item.isMe) {
            this.handleRemoteVideoMute({ userId: item.userID, isMute });
          }
        });
      }
    },
    // 自己的摄像头开/关
    handleSelfVideoMute(data = {}, fromUserId = "") {
      const { isMute } = data;
      const slefItem = this.personList.find(
        (item) => item.userID === this.userInfo.user_id
      );
      const isFromSelf = fromUserId === this.userStatus.user_id;
      if (isFromSelf) {
        // 如果来源是自己，不改自己的权限，只改状态
        this.setUserStatus({
          video_state: isMute ? 2 : 1,
        });
        this.changeUserStatus.video_state = isMute ? 2 : 1;
        return;
      }
      if (slefItem) {
        if (isMute !== slefItem.videoClose && isMute) {
          // 关闭摄像头
          slefItem.videoClose = true;
        } else if (isMute !== slefItem.videoClose && !isMute) {
          // 打开摄像头
          this.setShowOpenVideoDialog(true);
        }
      }
      if (isMute) {
        this.setShowOpenVideoDialog(false);
      }
      this.setUserStatus({
        is_send_video: isMute ? 2 : 1,
        video_state: slefItem.videoClose ? 2 : 1,
      });
      this.changeUserStatus.video_state = slefItem.videoClose ? 2 : 1;
      this.changeUserStatus.is_send_video = isMute;
    },
    // 远端用户的摄像头开关
    handleRemoteVideoMute(data = {}) {
      const { userId, isMute } = data;
      const status = {
        user_id: userId,
        is_send_video: isMute ? 2 : 1,
      };
      if (isMute) {
        status.video_state = 2;
      }

      // // 记录远端用户的摄像头状态变更
      // this.recordRemoteUserStatusChange(userId, {
      //   is_send_video: isMute ? 2 : 1,
      //   video_state: isMute ? 2 : status.video_state,
      // });

      this.updateAllMemberStatus({
        ...status,
      });
    },
    //////////////////////////////////////////////// 移除人员 ////////////////////////////////////////////////
  },
  beforeDestroy() {
    Object.keys(this._personListEventBusHandlers).forEach((eventName) => {
      EventBus.$off(eventName, this._personListEventBusHandlers[eventName]);
    });
    Object.keys(this._personListLiveServiceHandlers).forEach((eventName) => {
      this.liveService.off(
        eventName,
        this._personListLiveServiceHandlers[eventName]
      );
    });
    Object.keys(this._personListImServiceHandlers).forEach((eventName) => {
      this.imService.off(
        eventName,
        this._personListImServiceHandlers[eventName]
      );
    });
  },
};
